
import { dataAttrToKey } from './dom-helpers';
import delegateListener from './delegate-listener';

/**
 * Hides and shows elements when an input changes. The input should have a list of selectors to hide and/or show.
 */
class HideShowElements {
  constructor(options = {}) {
    const defaults = {
      hideListAttribute: 'data-hide-elements',
      showListAttribute: 'data-show-elements',
      hiddenClass: 'hidden'
    };

    Object.assign(this, defaults, options);
  }

  /**
   * Handles initializing the module
   */
  init() {
    this.bindEvents();
    this.setInitialState();
  }

  /**
   * Binds event listeners
   */
  bindEvents() {
    document.addEventListener('change', delegateListener(
      `[${ this.hideListAttribute }],[${ this.showListAttribute }]`,
      this.handleChangeEvent.bind(this)
    ));
  }

  /**
   * Handles a 'change' event by selecting and showing/hiding the elements found via the target element's show/hide attributes.
   *
   * @param {Event|Object} event - The event object, or an object pointing to the target with a `delegateTarget` key.
   */
  handleChangeEvent(event) {
    const target = event.delegateTarget || event.currentTarget;
    const hideSelector = target.dataset[dataAttrToKey(this.hideListAttribute)];
    const showSelector = target.dataset[dataAttrToKey(this.showListAttribute)];

    if(hideSelector) {
      document.querySelectorAll(hideSelector).forEach(
        this.toggleElementVisibility(false),
        this
      );
    }
    if(showSelector) {
      document.querySelectorAll(showSelector).forEach(
        this.toggleElementVisibility(true),
        this
      );
    }
  }

  /**
   * Toggles an element's visibilty with a class.
   *
   * @param {boolean} visible - Falsey values add a 'hidden' class, truthy values remove it.
   *
   * @returns {function} - A function that can be used as a forEach handler
   */
  toggleElementVisibility(visible) {
    return (element) => {
      element.classList.toggle(this.hiddenClass, !visible);
    }
  }

  /**
   * Sets the initial visibility by elements' checked state
   */
  setInitialState() {
    const checked = document.querySelectorAll(
      `[${ this.hideListAttribute }]:checked,[${ this.showListAttribute }]:checked`
    );

    checked.forEach((el) => this.handleChangeEvent({ delegateTarget: el }), this);
  }
}

module.exports = HideShowElements;
